<div *ngIf="form" [formGroup]="form">
    <div layout-gt-sm="row" layout="column">
        <!-- #region Name -->
        <mat-form-field layout-margin flex-gt-sm="60" flex>
            <mat-label i18n>Name</mat-label>
            <input matInput [readonly]="readonly" formControlName="name" [required]="required">
            <mat-error *ngFor="let errorMessage of form.controls.name['errorMessages']">{{errorMessage}}</mat-error>
        </mat-form-field>
        <!-- #endregion -->

        <!-- #region Billing period -->
        <mat-form-field layout-margin flex-gt-sm="30" flex *ngIf="showMinimumTerm">
            <mat-label i18n>Billing period</mat-label>
            <input matInput type="number" min="0" formControlName="minimumTerm">
            <mat-hint i18n>From X months</mat-hint>
            <mat-error *ngFor="let errorMessage of form.controls.minimumTerm['errorMessages']">{{errorMessage}}</mat-error>
        </mat-form-field>
        <!-- #endregion -->
    </div>

    <!-- #region Prices -->
    <div layout="column" layout-gt-sm="row">
        <app-price-reactive-form [form]="form" [required]="required" [readonly]="readonly" hideUnit="true" flex></app-price-reactive-form>
    </div>
    <!-- #endregion -->
</div>